import { CART_SERVICE } from "@/services/cart.service.js";

const state = {getCartOutput: {}, putCartOutput: false};

const actions = {
    //Service to get cart items
    getCart({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getCartRequest');

        CART_SERVICE.getCart()
            .then(
                output => {
                    commit('getCartSuccess', output);
                },
                error => {
                    commit('getCartFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to manage cart
    putCart({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCartRequest');

        CART_SERVICE.putCart(input)
            .then(
                output => {
                    commit('putCartSuccess', output);
                },
                error => {
                    commit('putCartFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getCart
    getCartRequest(state) {
    },
    getCartSuccess(state, output) {
        state.getCartOutput = output;
    },
    getCartFailure(state) {
        state.getCartOutput = false;
    },

    //putCart
    putCartRequest(state) {
        state.putCartOutput = null;
    },
    putCartSuccess(state, output) {
        state.putCartOutput = true;
    },
    putCartFailure(state) {
        state.putCartOutput = false;
    },
};

export const cart = {
    namespaced: true,
    state,
    actions,
    mutations
};